$(document).ready(function() {
	if(!document.querySelector('.GPC0015')) return false;

	/*
	if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
	} else {
		var $obj=$('.GPC0015');
		$obj.find('a[data-link-name=live_chat]').off().on('click', function(e) {
			e.preventDefault();
			ePrivacyCookies.view('click');
		});
	}
	*/

	// 20200319 START 박지영 :  br 국가별 설정 반영
	// LGEBR-3965 : 데스크탑에서는 whats app 숨김처리, 모바일에서는 livechat 숨김처리
	if(COUNTRY_CODE.toLowerCase()=='br') {
		if(isMobile) {
			$('.GPC0015 .contactus-box .list-box li.live-chat').remove();
		} else {
			$('.GPC0015 .contactus-box .list-box li.whats-app').remove();
		}
	}
	// 20200319 END
	
	$('.GPC0015').find('.contactus-box').each(function() {
		var obj = $(this);
		// 20200512 START 박지영 : 갯수에 따른 class명 추가
		var len = obj.find('ul.list-box li').length;
		if(len<4) {
			obj.find('ul').addClass('align-center');
		}
		obj.find('ul').addClass('len'+len);
		// 20200512 END
	});
});